export default "__VITE_ASSET__Bl1VLeU2__"